import {GeoPosition} from './geo-position';

export class LocationPlaceResult {
  city: string;
  region: string;
  geoPosition: GeoPosition;
}
